import React, { useState, useEffect, Fragment } from 'react'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'

import { validateStructure } from '../../../../../helpers/assignment'

import { CardContent, Grid, Typography } from '@material-ui/core'

import Tabs from '../../../../UI/Tabs/Tabs'
import StructureTable from './StructureTable/StructureTable'
import AssignActionControls from './StructureTable/AssignActionControls/AssignActionControls'
import AssignPeriod from './AssignPeriod/AssignPeriod'

const StructureTabs = ({
  inputChanged,
  frequencyOptions,
  assignmentData,
  addButtonClicked,
  actionDisabled,
  applyButtonClicked,
  submitButtonDisabled,
  submitButtonClicked,
  cancelButtonClicked,
  responsibleSearchChanged,
  assignmentTargetIds,
  fireAlert,
  appraisalType,
  translate,
  assignSuccessList,
  loadingQueue
}) => {
  const [currentTabIndex, setCurrentTabIndex] = useState(0)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    setTableData([...assignmentData])
    return () => {
      setTableData([])
    }
  }, [assignmentData])

  const tabs = tableData.map((structure, index) => ({
    key: `${structure.structure_id}-${index}`,
    label: structure.structure_name
  }))

  const tabContents = tableData.map((structure, index) => {
    const maxScore = structure.target_score
    const isValueGetZero = !!structure.is_get_zero
    const structureHasBeenSaved = (assignSuccessList || []).includes(structure.structure_id)
    const appraisalTypeCode = appraisalType.appraisal_type_code
    const structureTypeCode = structure.structure_type?.value_list_code
    const structureIsInvalid = !validateStructure(
      structure,
      structureTypeCode,
      appraisalTypeCode,
      frequencyOptions
    )

    let additionalDisplay = null
    if (structureTypeCode === 'STT05') {
      additionalDisplay = (
        <Grid container>
          <Grid item xs>
            <Typography variant={'h6'} align={'left'} paragraph>{`${translate(
              'structureWeight'
            )}: ${parseFloat(structure.weight_percent || 0).toFixed(2)} %`}</Typography>
          </Grid>
        </Grid>
      )
    }

    return {
      key: index,
      style: { padding: 0 },
      display: (
        <Fragment>
          <AssignPeriod structure={structure} inputChanged={inputChanged} translate={translate} />
          {additionalDisplay}
          <StructureTable
            appraisalType={appraisalType}
            fireAlert={fireAlert}
            assignmentTargetIds={assignmentTargetIds}
            structureData={{ ...structure }}
            frequencyOptions={frequencyOptions}
            loadingQueue={loadingQueue}
            // competencyTypes={competencyTypes}
            groupInputChanged={updatedStructure => inputChanged(updatedStructure)}
            groupItemInputChanged={updatedRow => {
              const updatedGroups = Object.entries(structure.result_item).reduce(
                (updated, group) => {
                  const [groupCode, groupAttrs] = group
                  const updatedGroupItems = groupAttrs.items.map(item => {
                    if (+item.item_id === +updatedRow.item_id) {
                      return { ...item, ...updatedRow }
                    }
                    return item
                  })
                  const updatedGroup = { ...groupAttrs, items: updatedGroupItems }
                  return { ...updated, [groupCode]: updatedGroup }
                },
                {}
              )
              const updatedStructure = { ...structure, result_item: updatedGroups }
              inputChanged(updatedStructure)
            }}
            groupItemDeleted={selectedRow => {
              const updatedGroups = Object.entries(structure.result_item).reduce(
                (updated, group) => {
                  const [groupCode, groupAttrs] = group
                  const updatedGroupItems = groupAttrs.items.filter(
                    item => +item.item_id !== +selectedRow.item_id
                  )
                  const updatedGroup = { ...groupAttrs, items: updatedGroupItems }
                  return { ...updated, [groupCode]: updatedGroup }
                },
                {}
              )
              const updatedStructure = { ...structure, result_item: updatedGroups }
              inputChanged(updatedStructure)
            }}
            responsibleSearchChanged={(searchValue, selectedRow) => {
              setTableData(prevState => {
                const dataCopy = [...prevState]
                const updatedData = dataCopy.map(st => {
                  if (
                    +st.result_structure_id === +structure.result_structure_id ||
                    +st.structure_id === +structure.structure_id
                  ) {
                    const updatedTarget = {
                      ...st,
                      result_item: st.result_item?.map(item => {
                        if (
                          +item.result_item_id === +selectedRow.result_item_id ||
                          +item.item_id === +selectedRow.item_id
                        ) {
                          return { ...item, ...selectedRow }
                        }
                        return item
                      })
                    }
                    inputChanged(updatedTarget)
                    return updatedTarget
                  }
                  return st
                })
                responsibleSearchChanged(searchValue, structure.structure_id, selectedRow)
                return updatedData
              })
            }}
            addButtonClicked={addButtonClicked}
            actionDisabled={actionDisabled}
            applyButtonClicked={applyButtonClicked}
            maxScore={maxScore}
            isValueGetZero={isValueGetZero}
            deleteRowClicked={rowData =>
              inputChanged({
                ...structure,
                result_item: [...structure.result_item].filter(
                  item => +item.item_id !== +rowData.item_id
                )
              })
            }
            inputChanged={(updatedItemRow, itemId, value) => {
              setTableData(prevState => {
                const dataCopy = [...prevState]
                const updatedData = dataCopy.map(st => {
                  if (
                    +st.result_structure_id === +structure.result_structure_id ||
                    +st.structure_id === +structure.structure_id
                  ) {
                    const updatedTarget = {
                      ...st,
                      result_item: st.result_item?.map(item => {
                        if (
                          +item.result_item_id === +updatedItemRow.result_item_id ||
                          +item.item_id === +updatedItemRow.item_id
                        ) {
                          return { ...item, ...updatedItemRow }
                        }
                        return {
                          ...item,
                          tableData: { ...item.tableData, showDetailPanel: undefined }
                        }
                      })
                    }
                    inputChanged(updatedTarget, structure.structure_id, itemId, value)
                    return updatedTarget
                  }
                  return st
                })
                return updatedData
              })
            }}
          />
          <AssignActionControls
            formInputChanged={updatedData => inputChanged(updatedData)}
            form={structure}
            submitButtonDisabled={
              structureIsInvalid || submitButtonDisabled || structureHasBeenSaved
            }
            submitted={() => submitButtonClicked(structure)}
            cancelled={cancelButtonClicked}
            stageList={structureHasBeenSaved ? [] : structure?.stage || []}
          />
        </Fragment>
      )
    }
  })

  return (
    <React.Fragment>
      <CardContent>
        <Tabs
          variant={'scrollable'}
          scrollButtons={'auto'}
          tabs={tabs}
          tabContents={tabContents}
          currentTabIndex={currentTabIndex}
          tabChanged={(e, newIndex) => setCurrentTabIndex(newIndex)}
        />
      </CardContent>
    </React.Fragment>
  )
}

export default withTranslate(StructureTabs)
